import { Group } from '@/components/_common';
import { useDisclosure, useWindowSize } from '@/hooks';
import { initialTabErrors } from '@/pages/SettingsPages/CustomerSettingsPage';
import { Button, Divider, Typography } from 'antd';
import RecommendationModal from './RecommendationModal';
import RecommendationList from './RecommendationList';

interface Props {
  handleTabError: (key: keyof typeof initialTabErrors) => void;
}

export default function CustomerRecommendationSettings({}: Props) {
  const { width } = useWindowSize();
  const [modalCreateRecommendationOpened, modalCreateRecommendationActions] =
    useDisclosure();

  return (
    <>
      <Group position="between">
        <Typography.Title level={4} style={{ margin: 0 }}>
          Recomendações
        </Typography.Title>

        {width >= 992 && (
          <Button
            type="primary"
            onClick={modalCreateRecommendationActions.open}
          >
            Criar recomendação
          </Button>
        )}
      </Group>

      <Divider />

      <RecommendationList />

      <RecommendationModal
        open={modalCreateRecommendationOpened}
        onCancel={modalCreateRecommendationActions.close}
      />
    </>
  );
}
